import Modal from 'src/components/modal/modal.vue'

import { useInstanceStore } from 'src/stores/instance.js'
import { useMergedConfigStore } from 'src/stores/merged_config.js'
import { useSyncConfigStore } from 'src/stores/sync_config.js'
import { useUsersStore } from 'src/stores/users.js'

import pleromaTanFoxMask from 'src/assets/pleromatan_apology_fox_mask.png'
import pleromaTanMask from 'src/assets/pleromatan_apology_mask.png'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

library.add(faTimes)

export const CURRENT_UPDATE_COUNTER = 2

const pleromaTan = '/static/pleromatan_apology.png'
const pleromaTanFox = '/static/pleromatan_apology_fox.png'

const UpdateNotification = {
  data() {
    return {
      showingImage: false,
      pleromaTanVariant: Math.random() > 0.5 ? pleromaTan : pleromaTanFox,
      showingMore: false,
    }
  },
  components: {
    Modal,
  },
  computed: {
    pleromaTanStyles() {
      const mask =
        this.pleromaTanVariant === pleromaTan
          ? pleromaTanMask
          : pleromaTanFoxMask
      return {
        'shape-outside': 'url(' + mask + ')',
      }
    },
    shouldShow() {
      return (
        !useInstanceStore().disableUpdateNotification &&
        useUsersStore().currentUser &&
        useSyncConfigStore().flagStorage.updateCounter <
          CURRENT_UPDATE_COUNTER &&
        !useMergedConfigStore().mergedConfig.dontShowUpdateNotifs
      )
    },
  },
  methods: {
    toggleShow() {
      this.showingMore = !this.showingMore
    },
    neverShowAgain() {
      this.toggleShow()
      useSyncConfigStore().setFlag({
        flag: 'updateCounter',
        value: CURRENT_UPDATE_COUNTER,
      })
      useSyncConfigStore().setSimplePrefAndSave({
        path: 'dontShowUpdateNotifs',
        value: true,
      })
      useSyncConfigStore().pushSyncConfig()
    },
    dismiss() {
      useSyncConfigStore().setFlag({
        flag: 'updateCounter',
        value: CURRENT_UPDATE_COUNTER,
      })
      useSyncConfigStore().pushSyncConfig()
    },
  },
  mounted() {
    this.contentHeightNoImage = this.$refs.animatedText.scrollHeight

    // Workaround to get the text height only after mask loaded. A bit hacky.
    const newImg = new Image()
    newImg.onload = () => {
      setTimeout(() => {
        this.showingImage = true
      }, 100)
    }
    newImg.src =
      this.pleromaTanVariant === pleromaTan ? pleromaTanMask : pleromaTanFoxMask
  },
}

export default UpdateNotification
